import { Link, useLocation } from "react-router-dom";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

const SidebarLink = ({ link, Icon, text, isOpen }) => {
  const location = useLocation();
  const isActive = location.pathname === link;

  return (
    <Link
      to={link}
      className={`flex items-center pl-7 gap-7 group relative transition-all duration-200 ${
        isActive
          ? "bg-amber-500/20 border-r-2 border-amber-500"
          : "hover:bg-zinc-800"
      }`}
    >
      {isActive && (
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-500" />
      )}

      <div className="gap-7 py-3 flex items-center w-full">
        <Icon
          className={`min-w-[24px] w-6 h-6 transition-colors duration-200 ${
            isActive
              ? "text-amber-500"
              : "text-white group-hover:text-amber-500"
          }`}
        />
        <span
          className={`whitespace-nowrap group-hover:-translate-x-2 transition-all duration-200 font-medium tracking-tight group-hover:text-amber-500 flex-1 text-left ${
            isActive ? "text-amber-500" : "text-white"
          }`}
        >
          {text}
        </span>
      </div>
    </Link>
  );
};

export default SidebarLink;